import { FetchBaseQueryMeta } from "@reduxjs/toolkit/query";
import { PaginationMetadata } from "../entities/common";

export function getPaginationFromMeta(meta?: FetchBaseQueryMeta): PaginationMetadata | null {
  const header = meta?.response?.headers.get("X-Pagination");
  return header ? JSON.parse(header) : null;
}

export const defaultPagination = (length: number) => ({
  pageNumber: 1,
  pageSize: length,
  totalCount: length,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false,
});
